import { SavedMemoryItemEdit } from "#features/personalization/components/SavedMemoryItemEdit.tsx";
import { SavedMemoryItemView } from "#features/personalization/components/SavedMemoryItemView.tsx";
import type { Memory } from "#features/personalization/hooks/useUpdatePersonalizationForm.ts";
import { Flex } from "@hopper-ui/components";
import { useCallback, useState } from "react";

interface Props {
    id: string;
    memory: Memory;
    onDelete: (id: string) => void;
    onUpdate: (id: string, value: string) => void;
}

export const SavedMemoryItem = ({ id, memory, onDelete, onUpdate }: Props) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleSaveEdit = useCallback((value: string) => {
        onUpdate(id, value);
        setIsEditing(false);
    }, [id, onUpdate]);

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="inline-sm"
        >
            {isEditing ? (
                <SavedMemoryItemEdit
                    defaultValue={memory.value}
                    onSave={handleSaveEdit}
                    onCancel={() => setIsEditing(false)}
                />
            ) : (
                <SavedMemoryItemView
                    memory={memory}
                    onDelete={() => onDelete(id)}
                    onStartEdit={() => setIsEditing(true)}
                />
            )}
        </Flex>
    );
};
